import objectHash from "object-hash";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectCurrentReport } from "../../../../store/selectors/currentReportSelectors";
import {
  selectSelectedDimensionNames,
  selectSelectedMeasureNames,
} from "../../../../store/selectors/fieldsStateSelectors";

const useDimensionAndMeasuresSelection = () => {
  const currentReport = useSelector(selectCurrentReport);
  const storedDimensionNames = useSelector(selectSelectedDimensionNames);
  const storedMeasureNames = useSelector(selectSelectedMeasureNames);

  const dimensionNamesHash = objectHash(storedDimensionNames ?? []);
  const measureNamesHash = objectHash(storedMeasureNames ?? []);

  const { dimensionNames, measureNames } = useMemo((): { dimensionNames: string[]; measureNames: string[] } => {
    return {
      dimensionNames: storedDimensionNames ?? [],
      measureNames: storedMeasureNames ?? [],
    };

    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [
    currentReport?.configuration,
    currentReport?.reportType,
    //Is used to trigger calling getCurrentReportConfigurationAsync when the fields are updated
    dimensionNamesHash,
    measureNamesHash,
    storedDimensionNames,
    storedMeasureNames,
  ]);
  return { dimensionNames, measureNames };
};

export default useDimensionAndMeasuresSelection;
